import Controller from '@ember/controller';
import backlinkViewControllerMixin from 'nightwatch-web/mixins/backlink-view-controller';

export default class DashboardUrlBacklinkViewController extends Controller.extend(
  backlinkViewControllerMixin
) {}
